<div>
  <button [disabled]="sendReportDisabled" mat-raised-button (click)="sendDailyReport()" i18n>Send daily report</button>
</div>
<div class="example-header">
  <mat-form-field style="margin-right: 80px">
    <input matInput (keyup)="applyFilter($event.target.value)" [value]="getListFilter()" placeholder="Filter">
  </mat-form-field>

  <mat-form-field>
    <input matInput #fromDate placeholder="From Date" [matDatepicker]="fromDate" disabled>
    <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
    <mat-datepicker (selectedChanged)="filterByFromDate($event)" #fromDate disabled="false"></mat-datepicker>
  </mat-form-field>

  <mat-form-field>
    <input matInput #toDate placeholder="To Date" [matDatepicker]="toDate" disabled>
    <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
    <mat-datepicker (selectedChanged)="filterByToDate($event)" #toDate disabled="false"></mat-datepicker>
  </mat-form-field>

  <button mat-raised-button (click)="resetDatePicker()">Reset Dates</button>
</div>

<div class="example-container mat-elevation-z8">

  <mat-table [dataSource]="dataSource" matSort>

    <ng-container matColumnDef="sent">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Sent</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="row.sent" [matTooltip]="row.sentOn"><mat-icon>mail</mat-icon></span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="budgetId">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Budget</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="row.budget.project">{{ row.budget | projectNr }}-</span>{{ row.budget.budgetNr }}</mat-cell>
    </ng-container>


    <ng-container matColumnDef="subBudgetId">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Sub Budget</mat-header-cell>
      <mat-cell *matCellDef="let row"> {{ row.subBudget.description }} </mat-cell>
    </ng-container>


    <ng-container matColumnDef="activityId">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Activity</mat-header-cell>
      <mat-cell *matCellDef="let row"> {{ row.activity.activity }} </mat-cell>
    </ng-container>


    <ng-container matColumnDef="hours">
      <mat-header-cell *matHeaderCellDef i18n>Hours</mat-header-cell>
      <mat-cell *matCellDef="let row"> {{ row.hours }} </mat-cell>
    </ng-container>


    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Date (Europe/Rome Time)</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.date | date:mediumDate:'+0200' }}</mat-cell>
    </ng-container>


    <ng-container matColumnDef="userId">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>User</mat-header-cell>
      <mat-cell *matCellDef="let row"> {{ row.user.displayName }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="description">
      <mat-header-cell *matHeaderCellDef i18n>Description</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <div [innerHtml]="row.description"></div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Actions</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <ng-template [ngIf]="canChangeUser || !row.sent">
          <button mat-icon-button (click)="editTimereport($event,row)">
            <mat-icon>mode_edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteTimereport($event,row)">
            <mat-icon>delete</mat-icon>
          </button>
        </ng-template>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [class.expanded]="expandedElement == row" (click)="expandedElement = row">
    </mat-row>
  </mat-table>

  <mat-paginator [length]="dataSource.resultsLength" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>


// WEBPACK FOOTER //
// ./src/app/timereport/timereport-list/timereport-list.component.html